var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4934 7.95413C25.7974 7.84607 26.0004 7.55819 26 7.23552C25.9996 6.91286 25.796 6.62549 25.4917 6.51814L13.2534 2.20016C13.0895 2.14227 12.9106 2.14227 12.7466 2.20016L0.508321 6.51814C0.20404 6.62544 0.000406859 6.91286 6.08716e-07 7.23552C-0.000405641 7.55819 0.202567 7.84607 0.506594 7.95413L5.35463 9.67764V14.6464C5.35463 15.4665 6.21014 16.16 7.8974 16.7076C9.36808 17.185 11.1803 17.4479 13.0001 17.4479C14.8198 17.4479 16.632 17.185 18.1027 16.7076C19.79 16.16 20.6455 15.4666 20.6455 14.6464V9.67764L22.6471 8.96605V15.8512C21.757 16.1659 21.1173 17.0154 21.1173 18.012C21.1173 19.0085 21.757 19.8581 22.6471 20.1729V23.0819C22.6471 23.5025 22.9882 23.8436 23.4088 23.8436C23.8295 23.8436 24.1706 23.5025 24.1706 23.0819V20.1729C25.0607 19.8581 25.7003 19.0086 25.7003 18.012C25.7003 17.0155 25.0607 16.1659 24.1706 15.8512V8.42441L25.4934 7.95413ZM23.4088 18.78C22.9853 18.78 22.6407 18.4355 22.6407 18.012C22.6407 17.5884 22.9853 17.2439 23.4088 17.2439C23.8323 17.2439 24.1769 17.5884 24.1769 18.012C24.1769 18.4355 23.8323 18.78 23.4088 18.78ZM13 3.72618L22.9566 7.23918L13 10.7788L3.04337 7.23913L13 3.72618ZM19.122 14.5316C18.976 14.6788 18.4533 15.0313 17.2738 15.3678C16.0153 15.7268 14.4975 15.9244 13 15.9244C11.5025 15.9244 9.98471 15.7268 8.72625 15.3678C7.54665 15.0313 7.02401 14.6788 6.87802 14.5316V10.2192L12.7448 12.3049C12.8273 12.3343 12.9137 12.3489 12.9999 12.3489C13.0863 12.3489 13.1726 12.3343 13.2551 12.3049L19.1219 10.2192V14.5316H19.122Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.e76e09a6680ac6932ca85db78bf02859.svg";
export { ForwardRef as ReactComponent };